import { render, staticRenderFns } from "./ContactMain.vue?vue&type=template&id=1860f74b&"
import script from "./ContactMain.vue?vue&type=script&lang=js&"
export * from "./ContactMain.vue?vue&type=script&lang=js&"
import style0 from "./ContactMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports